
import { useSystemNotifications } from "@/hooks/notifications/useSystemNotifications";

/**
 * Invisible component that activates system notification toasts for management users.
 * Mount this in DashboardLayout.
 */
const SystemNotificationPopup = () => {
  useSystemNotifications();
  return null;
};

export default SystemNotificationPopup;
